import { apiPath } from '../../constants';
import { axios, apiRequestOptions, errorRequestHandler, transformHttpResponse } from 'utils';

export const SCHEDULE_SETTINGS_SAVE_REQUEST = 'SCHEDULE_SETTINGS_SAVE_REQUEST';
export const SCHEDULE_SETTINGS_SAVE_SUCCESS = 'SCHEDULE_SETTINGS_SAVE_SUCCESS';
export const SCHEDULE_SETTINGS_SAVE_FAILURE = 'SCHEDULE_SETTINGS_SAVE_FAILURE';

// front/docs/SPA_ARCHITECTURE_AUDIT.md finding S3: drag-and-drop calls this
// on every single move with no debounce or in-flight cancellation. If two
// saves are in flight at once and their responses land OUT OF ORDER, the
// older (stale) response arriving last would silently overwrite the newer
// drag's result. `latestRequestId` lets a response recognize it's no longer
// the most recent request and skip dispatching — never letting a stale save
// win regardless of network ordering.
let latestRequestId = 0;

export const saveScheduleSettings = (data) => {
  return function (dispatch) {
    const requestId = ++latestRequestId;
    dispatch({ type: SCHEDULE_SETTINGS_SAVE_REQUEST });
    return axios(apiRequestOptions(apiPath.COMPETITION_SCHEDULE_SETTINGS.SAVE, data))
      .then(transformHttpResponse)
      .then(response => {
        if (requestId !== latestRequestId) return;
        dispatch({ type: SCHEDULE_SETTINGS_SAVE_SUCCESS, data: response.data });
      })
      .catch(error => transformHttpResponse(error.response))
      .catch(error => {
        if (requestId !== latestRequestId) return;
        dispatch({ type: SCHEDULE_SETTINGS_SAVE_FAILURE, error });
        dispatch(errorRequestHandler(error));
      });
  };
};
